/**
 * Клиентский раздел «Сотрудники» (company-structure): адресная книга сотрудников и управление
 * структурой (подразделения/рабочие места). Клиент работает в своём скоупе (companyApi, без client_id).
 * Доступно только роли company (физлицо структуры не имеет — гарантируется роутером).
 */
import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { companyApi, trainingApi } from '@/lib/api'
import { backState } from '@/lib/use-back-target'
import { PageHead } from '@/design-system/components/layout/page-head'
import { Button } from '@/design-system/components/primitives/button'
import { EmployeesManager } from '@/company/employees-manager'
import { StructureManager } from '@/company/structure-manager'

type View = 'employees' | 'structure'

/** Журнал сроков своей организации — источник колонки «Обучение» адресной книги. */
const loadTrainingJournal = (signal: AbortSignal) => trainingApi.journal(signal)

export function StaffPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const [view, setView] = useState<View>('employees')

  return (
    <div>
      <PageHead
        title="Сотрудники"
        subtitle="Структура компании: подразделения → рабочие места → сотрудники"
        actions={
          <div className="flex gap-2">
            <Button
              variant={view === 'employees' ? 'primary' : 'secondary'}
              onClick={() => setView('employees')}
            >
              Адресная книга
            </Button>
            <Button
              variant={view === 'structure' ? 'primary' : 'secondary'}
              onClick={() => setView('structure')}
            >
              Структура
            </Button>
          </div>
        }
      />

      {view === 'employees' ? (
        <EmployeesManager
          api={companyApi}
          loadTrainingJournal={loadTrainingJournal}
          onOpenEmployee={(id) => navigate(`/staff/${id}`, { state: backState(location) })}
        />
      ) : (
        <StructureManager api={companyApi} linkState={backState(location)} />
      )}
    </div>
  )
}
